import React from "react";
import { useTranslation } from 'react-i18next';

// MUI Components:
import {Box,Typography,Avatar, Divider,Paper, IconButton, Link} from '@mui/material'

// Icons:
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

// images
import prof_img from '../../assets/images/profilePic.jpg'

function QuickContact() {

    const { t, i18n } = useTranslation();
    return(

        <Box
            // elevation={2} 
            sx={{ width:'90%',
                  padding:'0rem',
                  margin:'1rem',
                  borderRadius:'1rem'
            }}>
            <Box 
                sx={{ width:'100%', 
                      marginBottom:'2rem',
                      marginTop:'1rem',
                      display:'flex',
                      flexDirection:{ xs: 'column', sm:'column', md:'column', lg:'colum', xl:'column'},
                      alignItems:{xs:'center', sm:'center', md:'center', lg:'center', xl:'center'}
                    
                    }}>

              {/* <Avatar alt="Remy Sharp"  
                    sx={{ width: '7rem', height: '7rem', opacity: 0.8 }} 
                    src={prof_img} /> */}
                <Typography variant="h6" sx={{fontWeight:'bold',margin:'0.5rem'}}>
                    {t('contact_section.title')}
                </Typography>

                    {/* orientation="vertical" */}
                {/* <Divider flexItem orientation="vertical" sx={{ display:{xs: 'none', sm:'none', md:'block', lg:'block', xl:'block'}}}/> */}
                <Divider flexItem  sx={{ display:{xs: 'block', sm:'block', md:'block', lg:'block', xl:'block'}}}/>

                <Box sx={{display:'flex' ,flexDirection:{ xs: 'column', sm:'column', md:'column', lg:'column', xl:'column'}}} >

                    <Box sx={{ display:'flex', 
                            flexDirection:'column',
                               alignItems:'center'}} component={IconButton} href="tel:+972559969449">
                        <IconButton >
                            <LocalPhoneOutlinedIcon>
                            </LocalPhoneOutlinedIcon>
                        </IconButton>
                        <Typography>
                            {t('contact_section.phone')}
                        </Typography>
                    </Box>

                    <Box sx={{  display:'flex', 
                                flexDirection:'column',
                                alignItems:'center'}} 
                         component={IconButton} 
                         href="https://api.whatsapp.com/send?phone=972559969449">
                        <IconButton>
                            <WhatsAppIcon/>
                        </IconButton>
                        <Typography>
                            {t('contact_section.phone')}
                        </Typography>
                    </Box>

                    <Box sx={ { display:'none', 
                                flexDirection:'column',
                                alignItems:'center'}} 
                                component={IconButton} 
                                href={`mailto:m.abdelhai@outlook.com`}
                                >
                        <IconButton variant="outlined" >
                            <DraftsOutlinedIcon/>
                        </IconButton>
                        <Typography>
                                {t('contact_section.email')}
                        </Typography>
                    </Box>



                    <Box sx={{ display:'flex',
                               flexDirection:'column',
                               alignItems:'center'}}>
                        <IconButton variant="outlined">
                            <LocationOnOutlinedIcon/>
                        </IconButton>

                        <Typography sx={{color:'#0000008A'}}>
                                {t('contact_section.address')}
                        </Typography>
                    </Box>

                </Box>
                
              
            </Box>
        </Box>
    );
    
}

export default QuickContact;